import {getName} from 'country-list';

export default function getCountryName(isoCode: string) {
  switch (isoCode.toUpperCase()) {
    case 'GB':
      return 'United Kingdom';
    case 'US':
      return 'United States';
  }
  return getName(isoCode.toUpperCase());
}
